"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useColumnsFromChildren = void 0;
var _react = _interopRequireWildcard(require("react"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function isExternalCallbackKey(key) {
  return ![
  // Mui grid fns
  'valueFormatter', 'valueGetter', 'renderCell',
  // Gg cell fns
  'formatter', 'getTooltip',
  // actions colDef
  'actionsComponent',
  // dynamic
  'predicate',
  // status colDef
  'getStatusColor',
  // link colDef
  'linkComponent',
  // list colDef
  'getItemValue', 'getItemTooltip', 'getItemIcon'].includes(key);
}
var useColumnsFromChildren = exports.useColumnsFromChildren = function useColumnsFromChildren(children) {
  var callbackRefs = _react["default"].useRef(null);
  if (!callbackRefs.current) {
    callbackRefs.current = {};
  }
  var _roughColumns = _react["default"].Children.toArray(children).map(function (_ref) {
    var props = _ref.props;
    var col = {};
    Object.keys(props).forEach(function (key) {
      var propValue = props[key];
      if (typeof propValue === 'function' && isExternalCallbackKey(key)) {
        var callbackKey = "".concat(col.field, "_CALLBACK_").concat(key);
        callbackRefs.current[callbackKey] = propValue;
        propValue = function propValue() {
          var _callbackRefs$current;
          return (_callbackRefs$current = callbackRefs.current)[callbackKey].apply(_callbackRefs$current, arguments);
        };
      }
      col[key] = propValue;
    });
    return col;
  });
  return (0, _react.useMemo)(function () {
    return _roughColumns;
  }, [getColumnKey(_roughColumns)]);
};
function getColumnKey(columns) {
  return JSON.stringify(columns
  // .map(({ width: _width, ...other }) => other)
  , function (key, value) {
    return typeof value === 'function' ? value.name || value.toString() : value;
  });
}